import { universalFetch } from "./common";
import type {
	FilesInterface,
	DocumentTypeEnum,
	MortgagePayloadInterface,
} from "../interfaces/mortgageDetailsInterface";

export const postMortgageDetails = async (buyer: MortgagePayloadInterface) => {
	try {
		const response = await universalFetch("/mortgages", "PUT", buyer);
		return response as MortgagePayloadInterface;
	} catch (error) {
		console.error("Failed to postMortgageDetails", error);
		throw error;
	}
};

export const submitMortgageDetails = async () => {
	try {
		const response = await universalFetch("/mortgages/submit", "POST");
		return response;
	} catch (error) {
		console.error("Failed to submitMortgageDetails", error);
		throw error;
	}
};

export const submitFiles = async () => {
	try {
		const response = await universalFetch("/files/submit", "POST");
		return response;
	} catch (error) {
		console.error("Failed to submitFiles", error);
		throw error;
	}
};

interface PostDocumentsResponse {
	id: string;
}

export const postDocuments = async (
	filename: string,
	type: DocumentTypeEnum,
	data: string,
	size: number,
): Promise<PostDocumentsResponse> => {
	try {
		const response = await universalFetch("/files", "POST", {
			filename,
			type,
			data,
			size,
		});
		return response as PostDocumentsResponse;
	} catch (error) {
		console.error("Failed to getProfile", error);
		throw error;
	}
};

export const getDocuments = async () => {
	try {
		const response = await universalFetch("/files", "GET");
		return response as FilesInterface[];
	} catch (error) {
		console.error("Failed to getDocuments", error);
		throw error;
	}
};

export const deleteDocument = async (documentId: string) => {
	try {
		const response = await universalFetch(`/files/${documentId}`, "DELETE");
		return response;
	} catch (error) {
		console.error("Failed to deleteDocument", error);
		throw error;
	}
};

export const getProfile = async () => {
	try {
		const response = await universalFetch("/mortgages", "GET");
		return response as MortgagePayloadInterface;
	} catch (error) {
		console.error("Failed to getProfile", error);
		throw error;
	}
};

export const startNewApplication = async () => {
	try {
		const response = await universalFetch("/mortgages/revoke", "POST");
		return response;
	} catch (error) {
		console.error("Failed to startNewApplication", error);
		throw error;
	}
};
